import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import './DownloadAppPage.css';

/** Default listing — override with REACT_APP_ANDROID_PLAY_STORE_URL if the package id changes. */
const DEFAULT_GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=za.co.sprouttech.letterquest';

const IOS_URL = process.env.REACT_APP_IOS_APP_STORE_URL?.trim();
const ANDROID_URL =
  process.env.REACT_APP_ANDROID_PLAY_STORE_URL?.trim() || DEFAULT_GOOGLE_PLAY_URL;

const pub = process.env.PUBLIC_URL || '';
const BADGES = {
  appStoreBlack: `${pub}/badges/app-store-black.svg`,
  appStoreWhite: `${pub}/badges/app-store-white.svg`,
  googlePlay: `${pub}/badges/google-play-badge.png`,
};

export default function DownloadAppPage() {
  return (
    <main className="download-app">
      <SeoHead
        title="Get the app"
        description="Download Letter Quest on Google Play for Android. Same word games, daily puzzles, and account sync as the website. iOS on the App Store is coming soon."
        path="/apps"
      />
      <div className="download-app__hero">
        <img
          className="download-app__icon"
          src={`${pub}/branding/app-icon-foreground.png`}
          alt=""
          width={96}
          height={96}
          decoding="async"
        />
        <h1 className="download-app__title">Letter Quest on mobile</h1>
        <p className="download-app__lead">
          The Android app is live on Google Play. An iOS version for the App Store is coming soon. Play the same daily
          puzzles, streaks, and leaderboards in the app as on the web — sign in with the same account to keep your
          progress in sync.
        </p>
      </div>

      <section className="download-app__stores" aria-label="App store links">
        <div className="download-app__stores-panel">
          <p className="download-app__stores-label">Download free</p>
          <div className="download-app__badges">
            {IOS_URL ? (
              <a
                className="download-app__store-link"
                href={IOS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={BADGES.appStoreBlack}
                  alt="Download on the App Store"
                  className="download-app__badge download-app__badge--apple download-app__badge--apple-light"
                  width={120}
                  height={40}
                  decoding="async"
                />
                <img
                  src={BADGES.appStoreWhite}
                  alt=""
                  className="download-app__badge download-app__badge--apple download-app__badge--apple-dark"
                  width={120}
                  height={40}
                  decoding="async"
                  aria-hidden="true"
                />
              </a>
            ) : (
              <div className="download-app__ios-soon" role="status">
                <span className="download-app__ios-soon-title">App Store (iOS)</span>
                <span className="download-app__ios-soon-note">Coming soon</span>
              </div>
            )}
            <a
              className="download-app__store-link"
              href={ANDROID_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={BADGES.googlePlay}
                alt="Get it on Google Play"
                className="download-app__badge download-app__badge--google"
                decoding="async"
              />
            </a>
          </div>
        </div>
      </section>

      <section className="download-app__more">
        <h2>Policies</h2>
        <p>
          <Link to="/privacy">Privacy Policy</Link>
          {' · '}
          <Link to="/terms">Terms of Use</Link>
        </p>
        <p>
          <Link to="/">← Back to games</Link>
        </p>
      </section>
    </main>
  );
}
